export enum XpoBoardApiAction {
  ToggleDataDrawer = 'toggleDataDrawer',
  ApplyFiltersCriteria = 'applyFiltersCriteria',
  ApplyFilterCriterion = 'applyFilterCriterion',
  HideView = 'hideView',
  ActivateView = 'activateView',
}

export type XpoBoardApiActionsHandler = (...args: any[]) => any;
